import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './analytics';

function AnalyticsListener() {
  const location = useLocation();

  useEffect(() => {
    const pagePath = `${location.pathname}${location.search}${location.hash}`;
    trackPageView(pagePath, typeof document !== 'undefined' ? document.title : undefined);
  }, [location]);

  return null;
}

export default AnalyticsListener;
